
import {
    Box, TextField, FormControl, InputAdornment, InputLabel, Input, IconButton, Button,
    Typography, Select, MenuItem, FormHelperText, Alert, Divider
} from '@mui/material';
import { AccountCircleOutlined, Visibility, VisibilityOff, LockOutlined, Group } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch, } from 'react-redux';
import { set } from 'lodash';
import { Tabs } from '../../../components/tabs';
import { Grid } from '../../../components/table';
import { CONFIG } from '../../../../config'
import axios from 'axios';
import { ToolBar } from '../../../components/toolbar';
import { Modal } from '../../../components/modal';
import { FormA } from '../../../components/form';
import moment from 'moment';
import { getFormState } from '../../../../helpers/form';
import dayjs from 'dayjs';
import { SelectA, FileUploadA, DatePickerA } from '../../../components/form';
import { AllocationUpload } from '../upload';
import { FollowUpList } from '../follow-up';
import { NewDataList } from '../new-data';
import { Today } from '../today';
import { Active } from './active';
import { Closed } from './closed';
import { LiveAllocation } from '../live-allocation';
import { SankalpList } from '../sankalp-data';
import { ECDList } from '../ecd-reports';
import { Cases } from './cases';
import { ActiveSameContact } from './active-same-contact';
const API_HOST = CONFIG.modules['accounts'].host


const items = {
    'Active': {
        name: 'Active',
        view: (socket) => <Active socket={socket} />
    },
    'Active(Same Contact)': {
        name: 'Active(Same Contact)',
        view: (socket) => <ActiveSameContact socket={socket} />
    },
    'Closed': {
        name: 'Closed',
        view: (socket) => <Closed socket={socket} />
    },
    'Cases': {
        name: 'Cases',
        view: (socket) => <Cases socket={socket} />
    }

}

const markStyle = { borderRadius: 1, ml: 2, minWidth: 300, background: '#F3D55B', mb: 3, height: 40, pl: 2, display: 'flex', alignItems: 'center' }

const wrap = { display: 'flex', alignItems: 'center', justifyContent: 'space-between' }
const text2 = { fontSize: '.8em' }
export const MasterDatabase = (props) => {

    // variables relation to socket

    const { roles, user, users, Designations, Departments, Languages, Districts, Campaigns } = useSelector((state) => (state.user || {}))
    const { state } = props.location


    console.log(state, 'props route');

    const [active, setActive] = useState('Active')


    return (
        <>
            <Tabs
                items={items}
                active={active}
                state={state}
                onChange={(key) => {
                    setActive(key)
                }}
            />
            {
                items[active] && items[active].view && props.socket &&
                items[active].view(props.socket)
            }

        </>
    )
}